// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6329) return "static/chunks/6329-65e3a7517765bd96.js";
	if (chunkId === 7612) return "static/chunks/7612-503cf0c51c10df61.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2424":"64a24e96b0b0056d","5772":"b291999af6fa2fc8","9100":"2c375a2f3bcf2ff0"}[chunkId] + ".js";
};